import { Stack } from '@mui/material'
import { useEffect } from 'react'

interface ConfigLayoutProps {
  title: string
  header?: React.ReactNode
  footer?: React.ReactNode
  rightLayout?: React.ReactNode
  children?: React.ReactNode
  fullWidth?: boolean
  /** Keeps an embedded setup flow inside the browser viewport. */
  constrainViewport?: boolean
}

const SetUpLayout = ({
  title = '',
  children,
  footer,
  header,
  rightLayout,
  fullWidth = false,
  constrainViewport = false,
}: ConfigLayoutProps) => {
  useEffect(() => {
    document.title = `${title} | Cisgenics Admin`
  }, [title])

  return (
    <Stack
      minHeight="100vh"
      height={constrainViewport ? '100vh' : undefined}
      bgcolor="background.default"
      direction="row"
      flexGrow="1"
      overflow={constrainViewport ? 'hidden' : undefined}
    >
      {rightLayout ? (
        <Stack
          sx={{
            width: '95%',
            flexGrow: 1,
            overflow: 'hidden',
            minHeight: constrainViewport ? 0 : undefined,
          }}
        >
          {header}
          <Stack
            sx={{
              padding: fullWidth ? '0px' : '25px 32px',
              flexGrow: 1,
              minHeight: constrainViewport ? 0 : undefined,
              overflow: constrainViewport ? 'hidden' : undefined,
            }}
            className="setuplayout-children"
          >
            {children}
          </Stack>
          <Stack sx={{ display: 'flex', bottom: '0', justifyContent: 'end' }}>
            {footer}
          </Stack>
        </Stack>
      ) : (
        <Stack
          sx={{
            width: '100%',
            flexGrow: 1,
            minHeight: constrainViewport ? 0 : undefined,
          }}
        >
          {header}
          <Stack
            sx={{
              padding: fullWidth ? '0px' : '25px 32px',
              flexGrow: 1,
              minHeight: constrainViewport ? 0 : undefined,
              overflow: constrainViewport ? 'hidden' : undefined,
            }}
            className="setuplayout-children"
          >
            {children}
          </Stack>
          <Stack sx={{ display: 'flex', bottom: '0', justifyContent: 'end' }}>
            {footer}
          </Stack>
        </Stack>
      )}
      {/* Rendered only when there is something to put in it: an empty
          flex-grow:1 column used to eat half the page's width. */}
      {rightLayout && (
        <Stack
          sx={{
            display: 'flex',
            bottom: '0',
            justifyContent: 'right',
            flexGrow: '1',
          }}
        >
          {rightLayout}
        </Stack>
      )}
    </Stack>
  )
}

export default SetUpLayout
